module.exports = __webpack_public_path__ + "static/img/s147.cacbf69d.png";